import { render } from "./VerticalContainerProduction.vue.js?vue&type=template&id=607f5058!=!../../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./VerticalContainerProduction.vue?vue&type=template&id=607f5058"
import script from "./VerticalContainerProduction.vue.js?vue&type=script&lang=js!=!../../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./VerticalContainerProduction.vue?vue&type=script&lang=js"
export * from "./VerticalContainerProduction.vue.js?vue&type=script&lang=js!=!../../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./VerticalContainerProduction.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-components/render-engine/components/production/elements/layouts/VerticalContainerProduction.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "607f5058"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('607f5058', __exports__)) {
    api.reload('607f5058', __exports__)
  }
  
  module.hot.accept("./VerticalContainerProduction.vue.js?vue&type=template&id=607f5058!=!../../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./VerticalContainerProduction.vue?vue&type=template&id=607f5058", () => {
    api.rerender('607f5058', render)
  })

}


export default __exports__